module.exports = "/_next/static/resources/single-043e2e4d7f7ccc7d94c40dea5b8c6815.jpg";